import React from 'react';
import PropTypes from 'prop-types';
import './ScatterPlot.css';

/**
 * DeputadoTooltip component displays detailed information about a deputy
 * when hovering over a point in the scatter plot
 * 
 * @param {Object} props - Component props
 * @param {Object} props.deputado - Deputy data object
 * @param {boolean} props.visible - Whether the tooltip is visible
 * @param {Object} props.position - Position of the tooltip {x, y}
 * @returns {JSX.Element} - Rendered component
 */
const DeputadoTooltip = ({ deputado, visible, position, onClose }) => {
  if (!visible || !deputado) return null;

  // No need for positioning styles as we're using CSS to center the tooltip
  const tooltipStyle = {
    display: visible ? 'flex' : 'none',
  };

  // Handle close button click
  const handleClose = (e) => {
    e.stopPropagation();
    if (onClose) onClose();
  };
  
  // Handle action button click
  const handleActionClick = (e) => {
    e.stopPropagation();
    alert(`Você clicou no perfil de ${deputado.nome}!`);
  };

  // Determine gender for title (this is a simplification, in a real app you'd have this data)
  const title = deputado.nome.endsWith('a') ? 'DEPUTADA' : 'DEPUTADO';
  
  return (
    <div className="deputado-tooltip" style={tooltipStyle}>
      <div className="tooltip-content" onClick={(e) => e.stopPropagation()}>
        <button className="tooltip-close-btn" aria-label="Fechar" onClick={handleClose}>×</button>
        <div className="tooltip-header">
          <div className="deputy-photo">
            <img src={deputado.foto} alt={deputado.nome} />
          </div>
          <div className="deputy-score">
            <span className="score-value">{deputado.desempenho > 0 ? '+' : ''}{deputado.desempenho}</span>
          </div>
        </div>
        
        <div className="tooltip-body">
          <div className="deputy-title">{title}</div>
          <h2 className="deputy-name">{deputado.nome.toUpperCase()}</h2>
          <div className="deputy-party-state">
            {deputado.partido} - {deputado.estado}
          </div>
          
          <div className="deputy-ranking">
            <span className="ranking-position">{deputado.ranking}ª</span> no ranking
          </div>
          
          <div className="deputy-proposals">
            {deputado.propostas} PROPOSTAS
          </div>
          
          <button className="deputy-action-btn" onClick={handleActionClick}>
            Ver Perfil Completo
          </button>
        </div>
      </div>
    </div>
  );
};

DeputadoTooltip.propTypes = {
  deputado: PropTypes.shape({
    id: PropTypes.number.isRequired,
    nome: PropTypes.string.isRequired,
    partido: PropTypes.string.isRequired,
    estado: PropTypes.string.isRequired,
    foto: PropTypes.string.isRequired,
    desempenho: PropTypes.number.isRequired,
    media: PropTypes.number.isRequired,
    propostas: PropTypes.number.isRequired,
    ranking: PropTypes.number.isRequired
  }),
  visible: PropTypes.bool.isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired,
  onClose: PropTypes.func
};

export default DeputadoTooltip;
